import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronArrowRightFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M12.258 6.792c-.177-.83-.29-1.76-.36-2.792h2.405c.064.874.162 1.632.302 2.292.298 1.395.766 2.25 1.424 2.833.676.597 1.694 1.035 3.338 1.31.764.127 1.635.215 2.633.272v2.586c-.998.057-1.87.145-2.633.273-1.645.274-2.662.712-3.338 1.31-.658.582-1.126 1.437-1.424 2.832-.14.66-.238 1.418-.302 2.292h-2.406c.07-1.032.184-1.961.361-2.792.349-1.638.962-2.987 2.047-4.008H2v-2.4h12.305c-1.085-1.02-1.698-2.37-2.047-4.008"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ChevronArrowRightFilledSize24Glyph.displayName = 'ChevronArrowRightFilledSize24Glyph';
